import { useSmartMutation, useSmartQuery } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { uxHistoryApi } from "./api";

// Add your feature-specific hooks here
export const useUxHistory = () => {
  // Define your hooks
  return {};
};

export const useNotifications = ({
  remoteUtilityId,
  status,
  type,
  date,
  search,
  page = 1,
}: {
  remoteUtilityId: string;
  status?: string;
  type?: string;
  date?: string;
  search?: string;
  page?: number;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.ux.history.history(status, type, date, search, page),
    () =>
      uxHistoryApi.getNotificationHistory({
        remoteUtilityId,
        status,
        type,
        date,
        search,
      }),
    {
      enabled: !!remoteUtilityId,
    }
  );
};
export const useRunHistory = ({
  remoteUtilityId,
  status,
  type,
  date,
  search,
  page = 1,
}: {
  remoteUtilityId: string;
  status?: string;
  type?: string;
  date?: string;
  search?: string;
  page?: number;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.ux.history.runHistory(
      status,
      type,
      date,
      search,
      page
    ),
    () =>
      uxHistoryApi.getRunHistory({
        remoteUtilityId,
        status,
        type,
        date,
        search,
        page,
      }),
    {
      enabled: !!remoteUtilityId,
    }
  );
};

// Hook for canceling scheduled notification
export const useCancelScheduledNotification = () => {
  return useSmartMutation(
    (notificationId: number) =>
      uxHistoryApi.cancelScheduledNotification(notificationId),
    {
      // You can add success/error callbacks here
      onSuccess: () => {
        // Optionally invalidate run history cache to refresh the table
        // queryClient.invalidateQueries(['ux', 'history', 'runHistory']);
      },
    }
  );
};

export const useNotificationDetailsForRun = ({
  remoteUtilityId,
  runId,
  search,
  page = 1,
}: {
  remoteUtilityId: string;
  runId: string;
  search?: string;
  page?: number;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.ux.history.notificationDetailsForRun(
      runId,
      search,
      page
    ),
    () =>
      uxHistoryApi.getNotificationDetailsForRun({
        remoteUtilityId,
        runId,
        search,
        page,
      }),
    {
      enabled: !!remoteUtilityId && !!runId,
    }
  );
};

// Hook for scheduled notification details (for the view page)
// export const useScheduledNotificationDetails = ({
//   remoteUtilityId,
//   search,
//   page = 1,
// }: {
//   remoteUtilityId: string;
//   search?: string;
//   page?: number;
// }) => {
//   return useSmartQuery(
//     QueryKeyFactory.module.ux.history.scheduledDetails(search, page),
//     () =>
//       uxHistoryApi.getScheduledNotificationDetails({
//         remoteUtilityId,
//         search,
//         page,
//       }),
//     {
//       enabled: !!remoteUtilityId,
//     }
//   );
// };

export const useScheduledNotificationDetails = ({
  remoteUtilityId,
  search,
  page,
  type,
  order,
}: {
  remoteUtilityId: string;
  search?: string;
  page?: number;
  type?: string;
  order?: string;
}) =>
  useSmartQuery(
    // Update query key to include filter parameters for proper caching
    QueryKeyFactory.module.ux.history.scheduledDetails(
      search,
      page,
      type,
      order
    ),
    () =>
      uxHistoryApi.getScheduledNotificationDetails({
        remoteUtilityId,
        search,
        page,
        type,
        order,
      }),
    {
      enabled: !!remoteUtilityId,
    }
  );
